export enum UserPreferenceKeyEnum {
    NewsletterDaily = "newsletter-daily",
    NewsletterWeekly = "newsletter-weekly",
    NewsletterMonthly = "newsletter-monthly",
    Language = "language",
    OperationalActivityReportWeekly = "operational-activity-report-weekly",
    ErrorReportDaily = "error-report-daily",
}

export type NewsletterPreferenceKeyEnum =
    | UserPreferenceKeyEnum.NewsletterDaily
    | UserPreferenceKeyEnum.NewsletterWeekly
    | UserPreferenceKeyEnum.NewsletterMonthly;

export type OperationalPreferenceKeyEnum = UserPreferenceKeyEnum.OperationalActivityReportWeekly;

export type ErrorPreferenceKeyEnum = UserPreferenceKeyEnum.ErrorReportDaily;

export const NEWSLETTER_PREFERENCE_KEY = [
    UserPreferenceKeyEnum.NewsletterDaily,
    UserPreferenceKeyEnum.NewsletterWeekly,
    UserPreferenceKeyEnum.NewsletterMonthly,
];

export const OPERATIONAL_PREFERENCE_KEY = [UserPreferenceKeyEnum.OperationalActivityReportWeekly];

export const ERROR_PREFERENCE_KEY = [UserPreferenceKeyEnum.ErrorReportDaily];

export enum NewsletterComparePeriodKeyEnum {
    DASHBOARD_COMPARE_PERIOD_KEY = "dashboardComparePeriodKey",
    ANALYZE_COMPARE_PERIOD_KEY = "analyzeComparePeriodKey",
}

export enum OperationalOptionKeyEnum {
    MAIN_COMPARE_PERIOD_KEY = "mainComparePeriodKey",
    OPERATIONAL_COMPARE_PERIOD_KEY = "operationalComparePeriodKey",
    POS_SECTION_LIST = "posSectionList",
    GROUP_SECTION_LIST = "groupSectionList",
    ORGANIZATION_SECTION_LIST = "organizationSectionList",
    COMPARE_METHOD = "compareMethod",
    REPORT_MODE_LIST = "reportModeList",
}
